module.exports = __webpack_public_path__ + "img/fr_failure_8.08d33632.png";